import React from 'react';

import { useHistory } from 'react-router-dom';

import {
  CommonContainer,
  HistoryBlock,
  HistoryURL,
  HistoryActiveStyle,
} from '../../components/common/Container';
import { SideSpacer } from '../../components/common/Spacer';
import SalesContainer from '../../containers/sales/SalesContainer';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';

const SalesPage = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  let history = useHistory();
  if (!user) {
    alert('잘못된 접근입니다 다시 로그인 해 주세요');
    history.push('/');
    return false;
  }
  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <CommonContainer>
          <HistoryBlock>
            <HistoryURL to="/sales" activeStyle={HistoryActiveStyle}>
              매출
            </HistoryURL>
          </HistoryBlock>
          <SalesContainer />
        </CommonContainer>
      </SideSpacer>
    </>
  );
};

export default SalesPage;
